import { useQuery } from '@tanstack/react-query';
import { JOIN_CONFIG_QUERY } from '../../services/talentJoinApi';

/** The page's switch, consent wording and clusters — read once per visit. */
export const useJoinConfig = () => useQuery(JOIN_CONFIG_QUERY);
